// @vendor
import { i18n } from 'core/i18n';
const { formatText } = i18n;
// @constants
const { getTranslatedCountry } = require('constants/countries');
const { getTranslatedRoad } = require('constants/typeOfRoads');


const intervenerNameIsEmpty = immIntervenerData => (
    !immIntervenerData
        || (!immIntervenerData.get('nombreEstampado')
            && !immIntervenerData.get('apellido1')
            && !immIntervenerData.get('apellido2'))
);

const intervenerAddressIsEmpty = immIntervenerData => (
    !immIntervenerData || !immIntervenerData.getIn([ 'listadoIdentificacionPersona', 'identificacion', 0 ])
);

const getFullName = immIntervenerData => {
    if (!immIntervenerData) {
        return '';
    }

    const firstName = immIntervenerData.get('nombreEstampado', '').trim();
    const lastName1 = immIntervenerData.get('apellido1', '').trim();
    const lastName2 = immIntervenerData.get('apellido2', '').trim();

    const space1 = !immIntervenerData.get('apellido1') ? '' : ' ';

    return `${firstName}${space1}${lastName1} ${lastName2}`.trim();
};

const getAddressPart1 = immAddress => {
    const typeOfRoad = immAddress.get('tipoVia', '').trim();
    const streetName = immAddress.get('nombreVia', '').trim();
    const numberStreet = immAddress.get('nroVia', '').trim();

    if (typeOfRoad && streetName && numberStreet) {
        return `${getTranslatedRoad(typeOfRoad)} ${streetName} ${numberStreet}`;
    }

    if (typeOfRoad && streetName && !numberStreet) {
        return `${getTranslatedRoad(typeOfRoad)} ${streetName}`;
    }

    if (!typeOfRoad && streetName && numberStreet) {
        return `${streetName} ${numberStreet}`;
    }

    if (!typeOfRoad && streetName && !numberStreet) {
        return streetName;
    }

    return '';
};

const getAddressPart2 = immAddress => {
    const restOfAddress = immAddress.get('resto', '').trim();
    const place = immAddress.get('plaza', '').trim();

    if (restOfAddress && place) {
        return `${restOfAddress} ${place}`;
    }

    if (!restOfAddress && place) {
        return place;
    }

    return restOfAddress;
};

const getAddressPart3 = immAddress => {
    const postalCode = immAddress.get('codigoPostal', '').trim();

    return postalCode ? `${getTranslatedCountry('ES')} (${postalCode})` : `${getTranslatedCountry('ES')}`;
};

const getFormattedAddress = immIntervenerData => {
    if (!immIntervenerData) {
        return '';
    }

    const immAddress = immIntervenerData.getIn([ 'listadoIdentificacionPersona', 'identificacion', 0 ]);

    if (!immAddress) {
        return '';
    }

    const addressPart1 = getAddressPart1(immAddress);
    const addressPart2 = getAddressPart2(immAddress);
    const addressPart3 = getAddressPart3(immAddress);

    if (addressPart1 && addressPart2) {
        return `${addressPart1}, ${addressPart2}, ${addressPart3}`;
    }

    if (!addressPart1 && addressPart2) {
        return `${addressPart2}, ${addressPart3}`;
    }

    if (addressPart1 && !addressPart2) {
        return `${addressPart1}, ${addressPart3}`;
    }

    return addressPart3;
};

const getKinshipText = (kinship) => {
    switch (kinship) {
        case 0:
            return formatText('contractsView-father');
        case 1:
            return formatText('contractsView-mother');
        case 2:
            return formatText('contractsView-guardian');
        default:
            return '';
    }
};

module.exports = {
    intervenerNameIsEmpty,
    intervenerAddressIsEmpty,
    getFullName,
    getFormattedAddress,
    getKinshipText
};
